import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList } from "vue"
import _imports_0 from '@/assets/icons/icon-lottrackr.svg'
import _imports_1 from '@/assets/icons/chevron-down.svg'
import _imports_2 from '@/assets/icons/icon-powered-by.svg'


const _hoisted_1 = { class: "header-container-search" }
const _hoisted_2 = { class: "wrapper-burger" }
const _hoisted_3 = {
  key: 1,
  class: "estate-map-wrapper-logo"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 2,
  class: "wrapper-input"
}
const _hoisted_7 = {
  key: 0,
  class: "navigation"
}
const _hoisted_8 = { class: "switch-item--text" }
const _hoisted_9 = {
  key: 1,
  class: "profile"
}
const _hoisted_10 = { class: "profile" }
const _hoisted_11 = { class: "profile-avatar" }
const _hoisted_12 = { class: "profile-name" }
const _hoisted_13 = { class: "menu" }
const _hoisted_14 = {
  key: 1,
  class: "estate-map-header"
}
const _hoisted_15 = { class: "estate-map-wrapper-logo" }
const _hoisted_16 = {
  key: 0,
  class: "wrapper-burger"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 0,
  class: "auth-actions"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "menu-title" }
const _hoisted_22 = ["src"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "menu-title" }
const _hoisted_26 = {
  key: 0,
  class: "wrapper-powered-by"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header", [{ 'estate-header': $props.estate }, { 'over-all': $props.overAll }]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["header-container", { container: $props.estate }])
    }, [
      ($setup.isLogged())
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: _normalizeClass(["burger", { 'burger-active': $setup.showMobileMenu }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showMobileMenu = !$setup.showMobileMenu))
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("div", null, null, -1),
                  _createElementVNode("div", null, null, -1),
                  _createElementVNode("div", null, null, -1)
                ]))], 2)
              ]),
              (!$props.estate)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "wrapper-logo",
                    onClick: $setup.onLogo
                  }, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("img", { src: _imports_0 }, null, -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    ($props.estate?._id && !$props.isEmbedded)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: { name: 'EstateMap', params: { estateId: $setup.props.estate._id } }
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", { src: $setup.logoUrl }, null, 8, _hoisted_4)
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : ($props.isEmbedded)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: $setup.logoUrl
                          }, null, 8, _hoisted_5))
                        : _createCommentVNode("", true)
                  ])),
              (!$props.estate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                : _createCommentVNode("", true)
            ]),
            (!$props.isEmbedded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (!$props.estate)
                    ? (_openBlock(), _createBlock($setup["SwitchComponent"], {
                        class: "navigation-items-wr",
                        key: $setup.navigationKey,
                        modelValue: $setup.activeNavItem,
                        "onUpdate:modelValue": [
                          _cache[1] || (_cache[1] = ($event: any) => (($setup.activeNavItem) = $event)),
                          $setup.onChangeNavidationItem
                        ],
                        list: $setup.getNormalizedNavigation,
                        customSwitches: ['active'],
                        slots: ['customSwitch']
                      }, {
                        customSwitch: _withCtx((item) => [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(item.label), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "list"]))
                    : _createCommentVNode("", true),
                  ($setup.isLogged())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode($setup["DropDown"], { placement: "right bottom" }, {
                          control: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, _toDisplayString($setup.getFirstLetter($setup.getUser().firstName)), 1),
                              _createElementVNode("div", _hoisted_12, "Hi, " + _toDisplayString($setup.getUser().firstName), 1),
                              _cache[9] || (_cache[9] = _createElementVNode("img", { src: _imports_1 }, null, -1))
                            ])
                          ]),
                          dropdown: _withCtx(() => [
                            _createElementVNode("ul", _hoisted_13, [
                              ($props.estate)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 0,
                                    onClick: $setup.onMyAccount
                                  }, "My Dashboard"))
                                : _createCommentVNode("", true),
                              _createElementVNode("li", { onClick: $setup.onProfile }, "My Profile"),
                              _createElementVNode("li", { onClick: $setup.onLogout }, "Log Out")
                            ])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              (!$props.hideAuthButtons)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["burger", { 'burger-active': $setup.showMobileMenu }]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showMobileMenu = !$setup.showMobileMenu))
                    }, [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("div", null, null, -1),
                      _createElementVNode("div", null, null, -1),
                      _createElementVNode("div", null, null, -1)
                    ]))], 2)
                  ]))
                : _createCommentVNode("", true),
              ($props.estate?._id && !$props.isEmbedded)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: { name: 'EstateMap', params: { estateId: $props.estate._id } }
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", { src: $setup.logoUrl }, null, 8, _hoisted_17)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : ($props.isEmbedded)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 2,
                      src: $setup.logoUrl
                    }, null, 8, _hoisted_18))
                  : _createCommentVNode("", true)
            ]),
            (!$props.hideAuthButtons)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("button", {
                    class: "sign-in",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('login')))
                  }, "Log in"),
                  _createElementVNode("button", {
                    class: "button primary sign-up",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('register')))
                  }, "Create Account")
                ]))
              : _createCommentVNode("", true)
          ]))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["mobile-menu", { show: $setup.showMobileMenu }])
    }, [
      _createElementVNode("ul", null, [
        ($setup.isLogged())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.customerNavigation, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "menu-item",
                  key: index,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.showMobileMenu = false))
                }, [
                  _createVNode(_component_router_link, {
                    class: "menu-link",
                    to: item.link
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "menu-icon",
                        src: require(`@/assets/icons/${item.icon}`)
                      }, null, 8, _hoisted_20),
                      _createElementVNode("div", _hoisted_21, _toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128)),
              _createElementVNode("li", {
                class: "menu-item",
                onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.showMobileMenu = false))
              }, [
                _createElementVNode("div", {
                  class: "menu-link",
                  onClick: $setup.onLogout
                }, [
                  _createElementVNode("img", {
                    class: "menu-icon",
                    src: require('@/assets/icons/icon-logout.svg')
                  }, null, 8, _hoisted_22),
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "menu-title red" }, "Log Out", -1))
                ])
              ])
            ], 64))
          : (!$setup.isLogged() && !$props.hideAuthButtons)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.logOutCustomerNavigation, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "menu-item",
                  key: index
                }, [
                  _createElementVNode("div", {
                    class: "menu-link",
                    onClick: ($event: any) => ($setup.handleLogOutUserMenu(item.emit))
                  }, [
                    _createElementVNode("img", {
                      class: "menu-icon",
                      src: require(`@/assets/icons/${item.icon}`)
                    }, null, 8, _hoisted_24),
                    _createElementVNode("div", _hoisted_25, _toDisplayString(item.label), 1)
                  ], 8, _hoisted_23)
                ]))
              }), 128))
            : _createCommentVNode("", true)
      ]),
      (!$setup.isLogged())
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("img", { src: _imports_2 }, null, -1)
          ]))]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}